export default {
  phone: 0,
  tablet: 768,
  desktop: 1200,
}
